import React, { useState } from "react";
import {
	Table,
	Input,
	Select,
	Button,
	Modal,
	Form,
	InputNumber,
	TimePicker,
	Upload,
} from "antd";
import {
	PlusOutlined,
	EyeOutlined,
	EditOutlined,
	DeleteOutlined,
} from "@ant-design/icons";
import useCourses from "../../../hooks/AdminDashboard/useCourses";

const { Option } = Select;

function Courses() {
	const {
		setSearchTerm,
		filterCategory,
		setFilterCategory,
		filterPrerequisites,
		setFilterPrerequisites,
		isModalVisible,
		modalType,
		selectedCourse,
		form,
		teachers,
		categories,
		preRequisites,
		filteredCourses,
		showModal,
		handleModalConfirm,
		handleModalCancel,
	} = useCourses();

	const [materials] = useState([{ key: Date.now() }]);
	const columns = [
		{
			name: "Course name",
			dataIndex: "name",
			key: "name",
			render: (names) => <div>{names}</div>,
		},
		{
			name: "Category",
			dataIndex: "category",
			key: "category",
			render: (category) => <div>{category.title}</div>,
		},
		{
			name: "Prerequisites",
			dataIndex: "prerequisiteCourses",
			key: "prerequisiteCourses",
			render: (prerequisites) => (
				<div>
					{prerequisites.map((prerequisite, index) => (
						<span key={index}>
							{prerequisite.name}
							{index < prerequisites.length - 1 && (
								<span className="mx-2">•</span>
							)}
						</span>
					))}
				</div>
			),
		},
		{
			name: "Actions",
			key: "actions",
			render: (_, record) => (
				<span className="space-x-2">
					<Button
						icon={<EyeOutlined />}
						onClick={() => showModal("view", "course", record)}
					/>
					<Button
						icon={<EditOutlined />}
						onClick={() => showModal("edit", "course", record)}
					/>
					<Button
						icon={<DeleteOutlined />}
						onClick={() => showModal("delete", "course", record)}
						danger
					/>
				</span>
			),
		},
	];

	const renderFormContent = () => {
		// Function to add a new resource card
		// const addResource = () => {
		// 	setMaterials([...materials, { key: Date.now() }]);
		// };

		// // Function to remove a resource card
		// const removeResource = (key) => {
		// 	setMaterials(materials.filter((resource) => resource.key !== key));
		// };

		// Function to detect file type
		const detectFileType = (file) => {
			if (!file) return "Unknown";
			const type = file.type.split("/")[0];
			switch (type) {
				case "image":
					return "Image";
				case "video":
					return "Video";
				case "application":
					return "Document";
				default:
					return "Other";
			}
		};

		switch (modalType) {
			case "view":
				return (
					<div style={{ padding: "20px", fontSize: "16px" }}>
						<h3
							style={{
								marginBottom: "20px",
								textAlign: "center",
								color: "#1890ff",
							}}
						>
							Course Details
						</h3>
						<div
							style={{
								display: "grid",
								gridTemplateColumns: "1fr 1fr", // Two columns layout
								gap: "20px",
								marginBottom: "20px",
							}}
						>
							<div
								style={{
									borderBottom: "1px solid #e8e8e8",
									paddingBottom: "10px",
								}}
							>
								<strong style={{ fontSize: "18px" }}>
									Course name:
								</strong>
								<p style={{ margin: "5px 0", color: "#555" }}>
									{selectedCourse?.name}
								</p>
							</div>
							<div
								style={{
									borderBottom: "1px solid #e8e8e8",
									paddingBottom: "10px",
								}}
							>
								<strong style={{ fontSize: "18px" }}>
									Category:
								</strong>
								<p style={{ margin: "5px 0", color: "#555" }}>
									{selectedCourse?.category.title}
								</p>
							</div>
							<div
								style={{
									borderBottom: "1px solid #e8e8e8",
									paddingBottom: "10px",
								}}
							>
								<strong style={{ fontSize: "18px" }}>
									Description:
								</strong>
								<p style={{ margin: "5px 0", color: "#555" }}>
									{selectedCourse?.description}
								</p>
							</div>
							<div
								style={{
									borderBottom: "1px solid #e8e8e8",
									paddingBottom: "10px",
								}}
							>
								<strong style={{ fontSize: "18px" }}>
									Prerequisites:
								</strong>
								<p style={{ margin: "5px 0", color: "#555" }}>
									{selectedCourse?.prerequisiteCourses?.map(
										(prerequisite, index) => (
											<span key={index}>
												{prerequisite.name}
												{index <
													selectedCourse
														.prerequisiteCourses
														.length -
														1 && (
													<span
														style={{
															margin: "0 8px",
														}}
													>
														•
													</span>
												)}
											</span>
										)
									)}
								</p>
							</div>

							<div
								style={{
									borderBottom: "1px solid #e8e8e8",
									paddingBottom: "10px",
								}}
							>
								<strong style={{ fontSize: "18px" }}>
									Days per week:
								</strong>
								<p style={{ margin: "5px 0", color: "#555" }}>
									{selectedCourse?.schedule.length}
								</p>
							</div>
							<div
								style={{
									borderBottom: "1px solid #e8e8e8",
									paddingBottom: "10px",
								}}
							>
								<strong style={{ fontSize: "18px" }}>
									Max Students:
								</strong>
								<p style={{ margin: "5px 0", color: "#555" }}>
									{selectedCourse?.maxStudents || "Not set"}
								</p>
							</div>
							<div
								style={{
									borderBottom: "1px solid #e8e8e8",
									paddingBottom: "10px",
								}}
							>
								<strong style={{ fontSize: "18px" }}>
									Duration In Minutes:
								</strong>
								<p style={{ margin: "5px 0", color: "#555" }}>
									{selectedCourse?.durationInMinutes}
								</p>
							</div>
							<div
								style={{
									borderBottom: "1px solid #e8e8e8",
									paddingBottom: "10px",
								}}
							>
								<strong style={{ fontSize: "18px" }}>
									Price:
								</strong>
								<p style={{ margin: "5px 0", color: "#555" }}>
									{selectedCourse?.price}
								</p>
							</div>
							<div style={{ gridColumn: "span 2" }}>
								<strong style={{ fontSize: "18px" }}>
									Session Times:
								</strong>
								<p style={{ margin: "5px 0", color: "#555" }}>
									{selectedCourse?.sessionTimes}
								</p>
							</div>
						</div>
					</div>
				);
			case "add":
			case "edit":
				return (
					<>
						<Form.Item
							name="name"
							label="Course name"
							rules={[{ required: true }]}
						>
							<Input />
						</Form.Item>
						<Form.Item
							name="category"
							label="Category"
							rules={[
								{
									required: true,
									message: "Please select a category!",
								},
							]}
							className="text-black"
						>
							<Select
								showSearch
								placeholder="Select a category"
								optionFilterProp="children"
								filterOption={(input, option) =>
									option?.children
										.toLowerCase()
										.includes(input.toLowerCase())
								}
							>
								{categories.map((category) => (
									<Select.Option
										key={category.id}
										value={category.id}
									>
										{category.title}
									</Select.Option>
								))}
							</Select>
						</Form.Item>

						<Form.Item
							name="description"
							label="Description"
							rules={[{ required: true }]}
						>
							<Input.TextArea />
						</Form.Item>
						<Form.Item name="prerequisites" label="Prerequisites">
							<Select>
								{preRequisites.map((preRequisite) => (
									<Option
										key={preRequisite._id}
										value={preRequisite._id}
									>
										{preRequisite.name}
									</Option>
								))}
							</Select>
						</Form.Item>
						<div className="flex">
							<Form.Item
								name="maxStudents"
								label="Max Students"
								rules={[{ required: true }]}
							>
								<InputNumber min={1} max={100} />
							</Form.Item>
							<Form.Item
								name="price"
								label="Course price"
								rules={[{ required: true }]}
							>
								<InputNumber min={0} />
							</Form.Item>
						</div>
						{materials.map((resource) => (
							<div
								key={resource.key}
								className="border p-4 rounded-lg shadow-md bg-gray-50 mb-4 relative"
							>
								<Form.Item
									name="image"
									label="Category image"
									getValueFromEvent={(e) => e.fileList[0]}
									// rules={[{ required: true }]}
								>
									<Upload
										beforeUpload={() => false}
										listType="text"
									>
										<input
											type="file"
											// onChange={handleImageChange}
											style={{ display: "none" }}
											id="category-image-input"
											accept="image/*"
											rules={[
												{
													required: true,
													message:
														"Please upload a file",
												},
											]}
										/>
										<label
											htmlFor="category-image-input"
											className="flex items-center justify-center border-dashed border-2 border-gray-300 rounded-lg h-36 cursor-pointer"
										>
											<>
												<PlusOutlined className="text-4xl text-blue-500" />
												<p className="mt-2 text-sm text-gray-600">
													Upload Image
												</p>
											</>
										</label>
									</Upload>
								</Form.Item>
								<Form.Item
									name="video"
									label="Category video"
									getValueFromEvent={(e) => e.fileList[0]}
									// rules={[{ required: true }]}
								>
									<Upload
										beforeUpload={() => false}
										listType="text"
									>
										<input
											type="file"
											// onChange={handleImageChange}
											style={{ display: "none" }}
											id="category-video-input"
											accept="video/*"
											rules={[
												{
													required: true,
													message:
														"Please upload a file",
												},
											]}
										/>
										<label
											htmlFor="category-video-input"
											className="flex items-center justify-center border-dashed border-2 border-gray-300 rounded-lg h-36 cursor-pointer"
										>
											<>
												<PlusOutlined className="text-4xl text-blue-500" />
												<p className="mt-2 text-sm text-gray-600">
													Upload Video
												</p>
											</>
										</label>
									</Upload>
								</Form.Item>
							</div>
						))}
						<div className="flex">
							<Form.Item
								name="durationHours"
								label="Duration Hours"
								rules={[{ required: true }]}
							>
								<InputNumber min={1} max={100} />
							</Form.Item>
							<Form.Item
								name="durationMinutes"
								label="Duration Minutes"
								rules={[
									{
										required: true,
										message: "Please select a duration!",
									},
								]}
							>
								<InputNumber min={0} max={55} step={5} />
							</Form.Item>
						</div>

						{modalType === "add" && (
							<Form.List name="teachers">
								{(fields, { add, remove }) => (
									<>
										{fields.map(
											({
												key,
												name,
												fieldKey,
												...restField
											}) => (
												<div
													key={key}
													style={{
														display: "flex",
														gap: "10px",
														alignItems: "center",
														marginBottom: "10px",
													}}
												>
													{/* for the  schefule or the day of the week */}
													<Form.Item
														name={[
															name,
															"scheduledates",
														]}
														rules={[
															{
																required: true,
																message:
																	"Please select at least one day!",
															},
														]}
														className="mt-4"
													>
														<Select
															mode="multiple"
															placeholder="Select days"
															allowClear
														>
															{[
																"Monday",
																"Tuesday",
																"Wednesday",
																"Thursday",
																"Friday",
																"Saturday",
																"Sunday",
															].map((day) => (
																<Select.Option
																	value={day}
																	key={day}
																>
																	{day}
																</Select.Option>
															))}
														</Select>
													</Form.Item>

													{/* start Time */}
													<Form.Item
														{...restField}
														name={[
															name,
															"startTime",
														]}
														fieldKey={[
															fieldKey,
															"startTime",
														]}
														rules={[
															{
																required: true,
																message:
																	"Start time is required",
															},
														]}
													>
														<TimePicker
															use12Hours
															format="h:mm A"
															placeholder="From"
														/>
													</Form.Item>

													{/* Teacher Dropdown */}
													<Form.Item
														{...restField}
														name={[name, "teacher"]}
														showSearch
														placeholder="Select a Teacher"
														optionFilterProp="children"
														filterOption={(
															input,
															option
														) =>
															option?.children
																.toLowerCase()
																.includes(
																	input.toLowerCase()
																)
														}
													>
														<Select placeholder="Select Teacher">
															{teachers.map(
																(teacher) => (
																	<Option
																		key={
																			teacher.id
																		}
																		value={
																			teacher.id
																		}
																	>
																		{
																			teacher.fullName
																		}
																	</Option>
																)
															)}
														</Select>
													</Form.Item>

													{/* Remove Button */}
													<div className="flex items-center">
														<Button
															type="dashed"
															onClick={() =>
																remove(name)
															}
															icon={
																<DeleteOutlined />
															}
															danger
														/>
													</div>
												</div>
											)
										)}

										{/* Add Button */}
										<Form.Item>
											<Button
												type="dashed"
												onClick={() => add()}
												block
												icon={<PlusOutlined />}
											>
												Add a Teacher
											</Button>
										</Form.Item>
									</>
								)}
							</Form.List>
						)}
					</>
				);
			case "delete":
				return <p>Are you sure you want to delete this course?</p>;
			default:
				return null;
		}
	};

	return (
		<div className="p-6 bg-white">
			<h2 className="text-2xl font-bold mb-4">Courses List</h2>

			{/* Filters */}
			<div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-4">
				<Input.Search
					placeholder="Search by course name..."
					onChange={(e) => setSearchTerm(e.target.value)}
					className="w-full"
				/>
				<Select
					showSearch
					value={filterCategory}
					onChange={(value) => setFilterCategory(value)}
					className="w-full"
					placeholder="Filter by Category"
				>
					<Option value="">All Categories</Option>
					{categories.map((category) => (
						<Option key={category.id} value={category.id}>
							{category.title}
						</Option>
					))}
				</Select>
				<Select
					showSearch
					value={filterPrerequisites}
					onChange={(value) => setFilterPrerequisites(value)}
					className="w-full"
					placeholder="Filter by Prerequisites"
				>
					<Option value="">All prerequisites</Option>
					{preRequisites.map((preRequisite) => (
						<Option key={preRequisite._id} value={preRequisite._id}>
							{preRequisite.name}
						</Option>
					))}
				</Select>
				<Button
					type="primary"
					icon={<PlusOutlined />}
					onClick={() => showModal("add", "course")}
					className="w-full"
				>
					Add Course
				</Button>
			</div>

			<Table
				dataSource={filteredCourses}
				columns={columns}
				rowKey="_id"
				pagination={false}
			/>

			<Modal
				name={`${
					modalType.charAt(0).toUpperCase() + modalType.slice(1)
				} Category`}
				open={isModalVisible}
				onCancel={handleModalCancel}
				footer={null} // Custom footer to handle form submission
			>
				<Form
					layout="vertical"
					form={form}
					onFinish={handleModalConfirm} // Handle submission
					initialValues={
						modalType === "edit" && selectedCourse
							? {
									name: selectedCourse.name,
									description: selectedCourse.description,
									category: selectedCourse.category._id,
									teachers: selectedCourse?.teachers.map(
										(teacher) => {
											// const now = new Date();
											// const splitTime = teacher.startTime
											// 	.slice(0, 5)
											// 	.split(":");
											// const date = now.setHours(
											// 	splitTime[0],
											// 	splitTime[1]
											// );
											return {
												teachername: teacher, // Assuming each teacher object has an `_id` field
												// startTime: date,
												// scheduledates:
												// 	teacher.scheduledates,
											};
										}
									),
									durationHours: Math.floor(
										selectedCourse.durationInMinutes / 60
									),
									durationMinutes:
										selectedCourse.durationInMinutes % 60,
									maxStudents: selectedCourse.maxStudents,
									prerequisites:
										selectedCourse.prerequisiteCourses,
							  }
							: {}
					}
				>
					{renderFormContent()}
					{modalType !== "view" && (
						<Form.Item>
							<Button type="primary" htmlType="submit">
								{modalType === "delete" ? "Confirm" : "Submit"}
							</Button>
						</Form.Item>
					)}
				</Form>
			</Modal>
		</div>
	);
}

export default Courses;
